export const MODEL_OUTPUT_ROOT = "/mnt/models/daat";

export function resolveTrainDagPath(model) {
    if (model?.dag_path) return model.dag_path;
    const { Model_ID, createdDate, model_name } = model || {};
    if (!Model_ID || !createdDate || !model_name) return "";
    const name = `${Model_ID}_${createdDate}_${model_name}`;
    return `${MODEL_OUTPUT_ROOT}/${name}/${name}_DAG.json`;
}
